import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useFormik } from "formik";
import * as Yup from "yup";
import TutorSidebar from '../../../../TutorSidebar/TutorSidebar';

const TutorObjectiveMockQuestions = () => {
    // State to store questions
    const [questions, setQuestions] = useState([
        {
            id: 1,
            questionText: "",
            marks: "",
            options: { A: "", B: "", C: "", D: "" },
            answer: "",
        },
    ]);
    const [questionIdCounter, setQuestionIdCounter] = useState(2);

    // Formik setup with validation schema
    const validationSchema = Yup.object().shape({
        questions: Yup.array().of(
            Yup.object().shape({
                questionText: Yup.string().required("Question is required"),
                marks: Yup.string().required("Marks are required"),
                options: Yup.object().shape({
                    A: Yup.string().required("Option A is required"),
                    B: Yup.string().required("Option B is required"),
                    C: Yup.string().required("Option C is required"),
                    D: Yup.string().required("Option D is required"),
                }),
                answer: Yup.string().required("Answer is required"),
            })
        ),
    });

    const formik = useFormik({
        initialValues: {
            questions: questions,
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {

            alert("Questions Submitted Successfully");
        },
    });

    // Function to add a new question
    const addQuestion = () => {
        const newQuestion = {
            id: questionIdCounter,
            questionText: "",
            marks: "",
            options: { A: "", B: "", C: "", D: "" },
            answer: "",
        };

        setQuestionIdCounter(questionIdCounter + 1);
        const updatedQuestions = [...formik.values.questions, newQuestion];
        setQuestions(updatedQuestions);
        formik.setFieldValue("questions", updatedQuestions);
    };

    // Function to delete a question
    const deleteQuestion = (id) => {
        const updatedQuestions = formik.values.questions.filter((q) => q.id !== id);
        setQuestions(updatedQuestions);
        formik.setFieldValue("questions", updatedQuestions);
    };
    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Add Question
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="add-new-course-sec">
                                    <h4 className="mb-4">Add Questions</h4>
                                    <div className="card bg-light">
                                        <div className="card-body">
                                            <div id="session-container">
                                                {formik.values.questions.map((question, index) => (
                                                    <div className="session mb-4" key={question.id}>
                                                        <div className="row mb-3">
                                                            <div className="col-lg-12">
                                                                <div className="input-group d-flex justify-content-between">
                                                                    <h6 className="mb-3">Question-{index + 1}</h6>
                                                                    <div>
                                                                        <input
                                                                            type="number"
                                                                            className="input-card-form"
                                                                            placeholder={`Marks for question - ${index + 1}`}
                                                                            value={question.marks}
                                                                            onChange={(e) =>
                                                                                formik.setFieldValue(
                                                                                    `questions.${index}.marks`,
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Question Text */}
                                                            <div className="col-lg-12">
                                                                <div className="input-group">
                                                                    <textarea
                                                                        className="input-card-form"
                                                                        placeholder="Write Question"
                                                                        value={question.questionText}
                                                                        onChange={(e) =>
                                                                            formik.setFieldValue(
                                                                                `questions.${index}.questionText`,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Options A, B, C, D */}
                                                            {["A", "B", "C", "D"].map((option) => (
                                                                <div className="row" key={option}>
                                                                    <div className="col-lg-1 col-md-1 col-1 pe-0">
                                                                        <h6 className="mb-0 fw-bold mt-2">{option}.</h6>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-11 col-11 ps-0">
                                                                        <div className="input-group">
                                                                            <input
                                                                                type="text"
                                                                                className="input-card-form"
                                                                                placeholder={`Write Option ${option}`}
                                                                                value={question.options[option]}
                                                                                onChange={(e) =>
                                                                                    formik.setFieldValue(
                                                                                        `questions.${index}.options.${option}`,
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            {/* Answer Selection */}
                                                            <div className="row">
                                                                <div className="col-lg-8">
                                                                    <div className="card">
                                                                        <div className="card-body">
                                                                            <h6 className="text-primary">Select Answer</h6>
                                                                            <div className="row">
                                                                                {["A", "B", "C", "D"].map((option) => (
                                                                                    <div className="col-lg-2 col-md-6 col-6" key={option}>
                                                                                        <span className="fw-bold">{option}</span>&nbsp;&nbsp;
                                                                                        <input
                                                                                            type="radio"
                                                                                            className="form-check-input"
                                                                                            name={`answer-${question.id}`}
                                                                                            checked={formik.values.questions[index].answer === option}
                                                                                            onChange={() =>
                                                                                                formik.setFieldValue(
                                                                                                    `questions.${index}.answer`,
                                                                                                    option
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Add and Delete Buttons */}
                                                            <div className="col-lg-12 plus-btn-sec d-flex justify-content-end">
                                                                {formik.values.questions.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger px-2 py-1 mt-3 mx-2"
                                                                        onClick={() => deleteQuestion(question.id)}
                                                                    >
                                                                        <i className="fa-solid fa-trash" />
                                                                    </button>
                                                                )}
                                                                {index === formik.values.questions.length - 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary px-2 py-1 mt-3"
                                                                        onClick={addQuestion}
                                                                    >
                                                                        <i className="fa-solid fa-plus" />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Submit Button */}
                                    <div className="row">
                                        <div className="col-lg-3">
                                            <button
                                                type="button"
                                                className="btn btn-primary fw-bold w-100 mb-4 mt-2"
                                                onClick={formik.handleSubmit}
                                                data-bs-toggle="modal" data-bs-target="#adminModal"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Modal */}
                <div
                    className="modal fade"
                    id="adminModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body my-4">
                                <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                                <h4 style={{ width: "74%" }}>
                                    We will reach you after getting approval from{" "}
                                    <span className="text-primary">Admin</span>
                                </h4>
                                <Link to="/tutor/dashboard">
                                    <button type="button" className="btn btn-primary mt-4 px-4 mb-5" data-bs-dismiss="modal">
                                        Okay
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default TutorObjectiveMockQuestions